import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import CompleteProfileSteps from "./components/CompleteProfileSteps";
import { useCurrentUser } from "../../hooks/useCurrentUser";

const CompleteYourProfile = () => {
  const { userData, refetchMe, isUserLoading } = useCurrentUser();
  const [isAllowToSubmit, setIsAllowToSubmit] = useState(false);

  return (
    <div className="bg-light h-screen overflow-auto scroll-smooth">
      <Header
        isAllowToSubmit={isAllowToSubmit}
        setIsAllowToSubmit={setIsAllowToSubmit}
      />

      <div className="xl:mx-40 mx-5">
        <CompleteProfileSteps
          userData={userData}
          refetchMe={refetchMe}
          isUserLoading={isUserLoading}
          setIsAllowToSubmit={setIsAllowToSubmit}
        />
      </div>
    </div>
  );
};

export default CompleteYourProfile;
